/* SKINGRAPHICA redesign: desktop mega menu from the store's main menu, and the transparent header offset */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var timer = null;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function lis() { return $$('.sg-hdr .mm-i.mm-hp'); }
  function mark() { var s = $('.sg-hdr-sec'); if (s) s.classList.toggle('sg-mo', !!$('.sg-hdr .mm-i.open')); }
  function set(li, on) {
    li.classList.toggle('open', on);
    var b = $('.mm-t', li);
    if (b && b.tagName === 'BUTTON') b.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function closeAll(except) { lis().forEach(function (li) { if (li !== except) set(li, false); }); mark(); }
  function open(li) { closeAll(li); set(li, true); mark(); }
  window.SG = window.SG || {};
  window.SG.closeMega = function () { closeAll(); };
  document.addEventListener('mouseover', function (e) {
    if (!canHover || !e.target.closest) return;
    var li = e.target.closest('.sg-hdr .mm-i');
    clearTimeout(timer);
    if (li && li.classList.contains('mm-hp')) {
      if (!li.classList.contains('open')) timer = setTimeout(function () { open(li); }, $('.sg-hdr .mm-i.open') ? 40 : 110);
    } else if ($('.sg-hdr .mm-i.open')) {
      timer = setTimeout(closeAll, li ? 60 : 200);
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('.sg-hdr .mm-hp > .mm-t');
    if (b) {
      e.preventDefault();
      var li = b.parentNode;
      clearTimeout(timer);
      if (li.classList.contains('open') && !(canHover && e.detail > 0)) closeAll();
      else open(li);
      return;
    }
    if (!e.target.closest('.sg-hdr .mm-p')) closeAll();
  });
  document.addEventListener('focusin', function (e) {
    if (!e.target.closest) return;
    var li = e.target.closest('.sg-hdr .mm-i');
    if (!li || !li.classList.contains('open')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var li = $('.sg-hdr .mm-i.open');
    if (li) { closeAll(); var b = $('.mm-t', li); if (b) b.focus(); }
  });
  /* transparent header: the page slides up under the header by exactly its height */
  function headerHeight() {
    var root = document.documentElement;
    if (!root.classList.contains('sg-tp')) return;
    var h = $('.sg-hdr-sec .sg-hdr');
    if (h && h.offsetHeight) root.style.setProperty('--sg-hh', h.offsetHeight + 'px');
  }
  window.addEventListener('resize', headerHeight);
  if (document.readyState !== 'loading') headerHeight();
  else document.addEventListener('DOMContentLoaded', headerHeight);
  window.addEventListener('load', headerHeight);
})();
/* content pages: content rises in on scroll, image bands drift with the scroll, and Add to bag opens the bag */
(function () {
  'use strict';
  window.SGQ = true;
  var root = document.documentElement;
  var mm = window.matchMedia ? function (q) { return window.matchMedia(q).matches; } : function () { return false; };
  var still = mm('(prefers-reduced-motion: reduce)');
  function reveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-q-rv]'));
    if (!els.length) return;
    if (still || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }
  function drift() {
    var bands = Array.prototype.slice.call(document.querySelectorAll('[data-q-par]'));
    if (!bands.length || still || !mm('(min-width: 750px)') || !('IntersectionObserver' in window)) return;
    var live = [];
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var i = live.indexOf(en.target);
        if (en.isIntersecting && i < 0) live.push(en.target);
        if (!en.isIntersecting && i > -1) live.splice(i, 1);
      });
      tick();
    }, { rootMargin: '15% 0px' });
    bands.forEach(function (b) { io.observe(b); });
    var queued = false;
    function frame() {
      queued = false;
      var vh = window.innerHeight;
      live.forEach(function (b) {
        var r = b.getBoundingClientRect();
        var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        if (p > 1) p = 1; if (p < -1) p = -1;
        var m = b.firstElementChild;
        if (m) m.style.transform = 'translate3d(0,' + (p * 7).toFixed(2) + '%,0)';
      });
    }
    function tick() { if (!queued) { queued = true; window.requestAnimationFrame(frame); } }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-sg-add],[data-sg-variant]') : null;
    var S = window.SG;
    if (!a || !S || !S.add || !S.openBag) return;
    e.preventDefault();
    if (a.classList.contains('in') || a.classList.contains('kitin')) { S.openBag(); return; }
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    var k = a.getAttribute('data-sg-add');
    var go = k ? S.add(k, 1) : S.addVariant(a.getAttribute('data-sg-variant'));
    Promise.resolve(go).then(function () { a.removeAttribute('aria-busy'); S.openBag(); }, function () { a.removeAttribute('aria-busy'); window.location.href = a.href; });
  });
  function init() { reveal(); drift(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
/* content pages v2: LUME size choice on product cards, the in-page index with question search, and tiers that open one at a time */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-sg-sz]') : null;
    if (!b) return;
    var card = b.closest('[data-sg-card]');
    if (!card) return;
    e.preventDefault();
    Array.prototype.forEach.call(card.querySelectorAll('[data-sg-sz]'), function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var add = card.querySelector('[data-sg-add]'); if (add) add.setAttribute('data-sg-add', b.getAttribute('data-sg-sz'));
    var pr = card.querySelector('[data-sg-price]'); if (pr) pr.textContent = b.getAttribute('data-sg-pr');
  });
  function toc() {
    var nav = document.querySelector('[data-pg-toc]');
    if (!nav) return;
    var list = nav.querySelector('[data-pg-toc-l]');
    var hs = Array.prototype.slice.call(document.querySelectorAll('.pgv [data-pg-sec][id]'));
    if (!hs.length) { list.hidden = true; } else {
      hs.forEach(function (h) {
        var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.getAttribute('data-pg-sec') || h.textContent.trim(); a.setAttribute('data-for', h.id);
        list.appendChild(a);
      });
      if ('IntersectionObserver' in window) {
        var links = list.querySelectorAll('a');
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (!en.isIntersecting) return;
            Array.prototype.forEach.call(links, function (l) {
              var on = l.getAttribute('data-for') === en.target.id;
              l.classList.toggle('on', on);
              if (on && list.scrollWidth > list.clientWidth) {
                /* measured against the chip row itself, so the first chip always sits fully inside the row's own margin */
                var pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
                var x = l === links[0] ? 0 : l.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft - pad;
                list.scrollTo({ left: Math.max(0, x), behavior: 'smooth' });
              }
            });
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        hs.forEach(function (h) { io.observe(h); });
      }
    }
    /* the index sits in its own section, so it is pinned under the header by script while the questions are on screen */
    var ph = document.createElement('div'); ph.className = 'pg-toc-ph'; nav.parentNode.insertBefore(ph, nav);
    var lastQ = function () { var a = document.querySelectorAll('.pgv [data-pg-sec][id], .pgv details.pg-q'); for (var i = a.length - 1; i >= 0; i--) { if (a[i].offsetParent) return a[i]; } return null; };
    var pinned = false, queued = false;
    function pin() {
      queued = false;
      var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sg-hdr')) || 64;
      var start = ph.getBoundingClientRect().top <= hh;
      var end = lastQ(); var past = end ? end.getBoundingClientRect().bottom < hh + nav.offsetHeight + 24 : false;
      var on = start && !past;
      if (on !== pinned) { pinned = on; nav.classList.toggle('pg-toc--pin', on); ph.style.height = on ? nav.offsetHeight + 'px' : '0px'; }
      document.documentElement.style.setProperty('--sg-toc-h', nav.offsetHeight + 'px');
    }
    window.addEventListener('scroll', function () { if (!queued) { queued = true; window.requestAnimationFrame(pin); } }, { passive: true });
    window.addEventListener('resize', pin);
    pin();
    var f = nav.querySelector('[data-pg-find]');
    if (f) {
      var qs = Array.prototype.slice.call(document.querySelectorAll('.pgv details.pg-q'));
      var none = nav.querySelector('[data-pg-none]');
      var clr = nav.querySelector('[data-pg-clear]');
      if (clr) clr.addEventListener('click', function () { f.value = ''; f.dispatchEvent(new Event('input', { bubbles: true })); f.focus(); });
      f.addEventListener('input', function () {
        var v = f.value.trim().toLowerCase(), hit = 0;
        qs.forEach(function (d) {
          var m = !v || d.textContent.toLowerCase().indexOf(v) > -1;
          d.hidden = !m; if (m) hit++;
          if (v && m && v.length > 2) d.open = true; else if (!v) d.open = false;
        });
        Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg-side'), function (s) {
          var vis = s.querySelectorAll('details.pg-q:not([hidden])').length;
          if (s.querySelector('details.pg-q')) s.hidden = !vis;
        });
        /* a section with no matching questions is folded away whole, so results sit together */
        Array.prototype.forEach.call(document.querySelectorAll('.pgv .pg'), function (s) {
          if (!s.querySelector('details.pg-q')) return;
          var w = s.closest('.shopify-section') || s;
          w.style.display = s.querySelector('details.pg-q:not([hidden])') ? '' : 'none';
        });
        Array.prototype.forEach.call(list.querySelectorAll('a'), function (l) {
          var t = document.getElementById(l.getAttribute('data-for'));
          l.style.display = t && !t.offsetParent ? 'none' : '';
        });
        if (none) none.hidden = hit > 0;
        /* filtering shortens the page, so bring the first result up under the pinned index */
        if (v && pinned) { var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sg-hdr')) || 64; window.scrollTo(0, ph.getBoundingClientRect().top + window.pageYOffset - hh); }
        pin();
      });
    }
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('pg-tier') || !d.open) return;
    var g = d.parentNode;
    Array.prototype.forEach.call(g.querySelectorAll(':scope > .pg-tier[open]'), function (x) { if (x !== d) x.open = false; });
  }, true);
  function hdr() { var h = document.querySelector('.sg-hdr-sec'); if (h && h.offsetHeight) document.documentElement.style.setProperty('--sg-hdr', h.offsetHeight + 'px'); }
  window.addEventListener('resize', hdr);
  function init() { hdr(); toc(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
/* swipe rows on phones: every row of systems carries the same "Swipe to see all" line as the homepage, and its marks follow the scroll */
(function () {
  'use strict';
  function wire(row) {
    var n = row.children.length, o = getComputedStyle(row).overflowX;
    if (n < 2 || (o !== 'auto' && o !== 'scroll')) return;
    var ind = row.nextElementSibling;
    if (!ind || !ind.classList.contains('sys-ind')) {
      ind = document.createElement('div');
      ind.className = 'sys-ind';
      ind.setAttribute('aria-hidden', 'true');
      var h = '';
      for (var i = 0; i < n; i++) h += i ? '<span></span>' : '<span class="on"></span>';
      ind.innerHTML = h + '<em>Swipe to see all ' + n + '</em>';
      row.parentNode.insertBefore(ind, row.nextSibling);
    }
    if (row.getAttribute('data-sg-ind')) return;
    row.setAttribute('data-sg-ind', '1');
    row.addEventListener('scroll', function () {
      var max = row.scrollWidth - row.clientWidth, cur = row.nextElementSibling;
      if (!cur || !cur.classList.contains('sys-ind') || max <= 0) return;
      var k = Math.round(row.scrollLeft / max * (n - 1));
      Array.prototype.forEach.call(cur.querySelectorAll('span'), function (s, j) { s.classList.toggle('on', j === k); });
    }, { passive: true });
  }
  var q = false;
  function all() { q = false; Array.prototype.forEach.call(document.querySelectorAll('.home .sys'), wire); }
  function soon() { if (!q) { q = true; window.requestAnimationFrame(all); } }
  function init() {
    all();
    if ('MutationObserver' in window && document.querySelector('.sgs-root, .home .sys')) new MutationObserver(soon).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
/* one current section only. A page listed under 2 menu sections is marked only under the section the visitor came in through, otherwise the first */
(function () {
  'use strict';
  var K = 'sg-mm-from';
  function title(el) { var t = el && el.querySelector(':scope > .mm-t, :scope > summary, :scope > a'); return t ? t.textContent.trim().toLowerCase() : ''; }
  function remember(e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var top = a.closest('.sg-hdr .mm-i, #sg-menu .mn-d'); if (!top) return;
    try { sessionStorage.setItem(K, JSON.stringify({ p: a.pathname, t: title(top) })); } catch (x) {}
  }
  function trim(list, cls, keep) {
    if (list.length < 2) return;
    var pick = list[0];
    if (keep) list.forEach(function (el) { if (title(el) === keep) pick = el; });
    list.forEach(function (el) { if (el === pick) return; if (cls === 'open') el.removeAttribute('open'); else el.classList.remove(cls); });
  }
  function run() {
    var keep = '';
    try { var s = JSON.parse(sessionStorage.getItem(K) || 'null'); if (s && s.p === location.pathname) keep = s.t; } catch (x) {}
    trim(Array.prototype.slice.call(document.querySelectorAll('.sg-hdr .mm-i.mm-cur')), 'mm-cur', keep);
    trim(Array.prototype.slice.call(document.querySelectorAll('#sg-menu .mn-d[open]')), 'open', keep);
  }
  document.addEventListener('click', remember, true);
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
/* in your bag, everywhere. Every add to bag button on the site shows the tick once its product is in the bag, and opens the bag instead of adding a second */
(function () {
  'use strict';
  var KIT = { system: ['prime', 'lock'], plus: ['prime', 'lock', 'shield'], lux: ['prime', 'lock', 'shield', 'lume'], legacy: ['shield', 'lume'] };
  var KN = { system: 'SYSTEM', plus: 'SYSTEM PLUS', lux: 'SYSTEM LUX' };
  var TICK = '<svg class="sg-in-t" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>';
  function state(S, a) {
    var k = a.getAttribute('data-sg-add');
    if (k) {
      if (S.has(k)) return ['in', 'In your bag'];
      /* the same product added from a client ordering page carries a tag, so it sits apart in the cart. It is still in the bag */
      var vid = S.cfg && S.cfg.v && +S.cfg.v[k];
      if (vid && S.other && S.other().some(function (it) { return it.variant_id === vid; })) return ['in', 'In your bag'];
      var base = /^lume/.test(k) ? 'lume' : k;
      for (var kit in KIT) { if (S.has(kit) && KIT[kit].indexOf(base) > -1) return ['kitin', 'In your ' + KN[kit]]; }
      return null;
    }
    var v = +a.getAttribute('data-sg-variant');
    if (v && S.other && S.other().some(function (it) { return it.variant_id === v; })) return ['in', 'In your bag'];
    return null;
  }
  function sync() {
    var S = window.SG; if (!S || !S.has) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-sg-add],[data-sg-variant]'), function (a) {
      var st = state(S, a), was = a.getAttribute('data-sg-in') || '';
      var now = st ? st[0] + '|' + st[1] : '';
      if (now === was) return;
      if (!a.hasAttribute('data-sg-lbl')) a.setAttribute('data-sg-lbl', a.innerHTML);
      a.classList.remove('in', 'kitin');
      if (st) {
        a.classList.add(st[0]);
        a.innerHTML = TICK + '<span class="t1">' + st[1] + '</span>';
        a.setAttribute('data-sg-in', now);
      } else {
        a.innerHTML = a.getAttribute('data-sg-lbl');
        a.removeAttribute('data-sg-in');
      }
    });
  }
  var on = false;
  function init() {
    var S = window.SG;
    if (!on && S && S.onCart) { S.onCart(sync); on = true; }
    sync();
  }
  document.addEventListener('sg:cart', sync);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-sg-sz]')) setTimeout(sync, 0); });
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
})();
/* bag savings. Shows automatic discounts the moment Shopify applies them, and a quiet large scale work nudge */
(function () {
  'use strict';
  var cart = null, busy = false, LIVE = Date.UTC(2026, 9, 31, 13);
  function cur() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD'; }
  function fmt(c) {
    var v = c / 100, whole = Math.round(v) === v;
    /* the store's own money format first, so savings read exactly like every other price in the bag in every language (31 Oct) */
    if (window.SG && typeof SG.money === 'function') return SG.money(v);
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: cur(), currencyDisplay: 'narrowSymbol', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v); } catch (e) { return '$' + v.toFixed(whole ? 0 : 2); }
  }
  function savings(c) {
    var m = {}, order = [];
    (c.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = inv((a.discount_application && a.discount_application.title) || 'Saving');
        if (!(t in m)) { m[t] = 0; order.push(t); } m[t] += a.amount;
      });
    });
    (c.cart_level_discount_applications || []).forEach(function (a) {
      var t = inv(a.title || 'Saving'); if (!(t in m)) { m[t] = 0; order.push(t); } m[t] += a.total_allocated_amount;
    });
    return order.filter(function (t) { return m[t] > 0; }).map(function (t) { return { t: t, a: m[t] }; });
  }
  /* a founder code reads as Founder pricing in the bag, not as the raw code */
  function inv(t) { try { var s = JSON.parse(localStorage.getItem('sg-inv') || 'null'); if (s && s.code && String(t).toUpperCase() === s.code.toUpperCase()) return 'Founder pricing'; } catch (e) {} return t; }
  function qty(c, h) { return (c.items || []).reduce(function (n, it) { return n + (it.handle === h ? it.quantity : 0); }, 0); }
  function nudge(c) {
    if (Date.now() < LIVE && !(window.Shopify && Shopify.theme && Shopify.theme.role === 'main')) return null; /* offers start the moment the theme is published (discounts switched on at publish), or 1 Nov AEDT at the latest */
    var lock = qty(c, 'lock'), lume = qty(c, 'lume'), kit = qty(c, 'system') + qty(c, 'system-plus') + qty(c, 'system-lux');
    if (lock === 1 && !kit) return { k: 'lock', t: 'Healing a large piece? Add a second LOCK and both are 20% off.', b: 'Add LOCK' };
    if (kit && !lock) return { k: 'lock', t: 'Healing a large piece? Add an extra LOCK at 20% off.', b: 'Add LOCK' };
    if (lume === 1) return { k: 'lume30', t: 'Restoring more than one piece? Add a second LUME and both are 20% off.', b: 'Add LUME' };
    return null;
  }
  function paint() {
    if (!cart) return;
    var rows = savings(cart), n = nudge(cart);
    [].forEach.call(document.querySelectorAll('.sum-row'), function (r) {
      var f = r.firstElementChild, ft = f ? f.textContent.trim() : '';
      if (ft !== 'Subtotal' && !(window.SG && SG.tr && ft === SG.tr('Subtotal'))) return;
      var box = r.parentNode;
      [].forEach.call(box.querySelectorAll('.sg-dsc'), function (x) { x.remove(); });
      var at = r;
      rows.forEach(function (s) {
        var d = document.createElement('div'); d.className = 'sum-row sg-dsc';
        d.innerHTML = '<span></span><span></span>'; d.firstChild.textContent = s.t; d.lastChild.textContent = '−' + fmt(s.a);
        at.parentNode.insertBefore(d, at.nextSibling); at = d;
      });
      /* with a saving showing, Subtotal reads the price before savings, so the sum adds up. Without one the bag's own figure stays (31 Oct) */
      var v = r.lastElementChild, sub = rows.length && cart.original_total_price != null ? fmt(cart.original_total_price) : null;
      if (sub && v && v !== f && v.textContent !== sub) v.textContent = sub;
      /* the cart page already closes on Total, so After savings only shows in the bag */
      if (rows.length && !box.querySelector('.tot')) {
        var tot = document.createElement('div'); tot.className = 'sum-row sg-dsc sg-dsc-t';
        tot.innerHTML = '<span></span><span></span>'; tot.firstChild.textContent = 'After savings'; tot.lastChild.textContent = fmt(cart.total_price);
        at.parentNode.insertBefore(tot, at.nextSibling);
      }
    });
    [].forEach.call(document.querySelectorAll('.dr-foot'), function (ft) {
      var old = ft.querySelector('.sg-nudge'); if (old) old.remove();
      if (!n) return;
      var d = document.createElement('div'); d.className = 'sg-nudge';
      d.innerHTML = '<p></p><button type="button"></button>'; d.firstChild.textContent = n.t; d.lastChild.textContent = n.b;
      d.lastChild.addEventListener('click', function () { var S = window.SG; if (S && S.add) Promise.resolve(S.add(n.k, 1)).then(function () { if (S.openBag) S.openBag(); }); });
      ft.insertBefore(d, ft.firstChild);
    });
    quiet();
  }
  /* a change asked for while a read is in flight reads again after it, so the savings always match the bag (31 Oct) */
  var again = false, seq = 0, waits = 0;
  /* while the bag is still saving a change, the figures wait for it rather than show the cart from before the tap */
  function saving() { try { return !!(window.SG && SG.subtotal && SG.subtotal(-1) === -1); } catch (e) { return false; } }
  function load() {
    if (busy) { again = true; return; }
    if (saving() && waits < 200) { waits++; clearTimeout(t); t = setTimeout(load, 150); return; }
    waits = 0; busy = true;
    var my = seq;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { busy = false; if (my === seq) { cart = c; paint(); } if (again) { again = false; load(); } }).catch(function () { busy = false; again = false; });
  }
  /* the bag's own update is the newest word, so a read that started before it is dropped */
  var fresh = 0;
  document.addEventListener('sg:cart', function (e) { if (e.detail && e.detail.items) { seq++; fresh = Date.now() + 1000; cart = e.detail; paint(); } else load(); });
  var t = null;
  /* the changes paint makes itself are dropped straight after it runs, so they never trigger another paint. Before this the bag repainted about 16 times a second whenever a nudge or saving showed, and taps on phones froze (31 Oct) */
  var obs = [];
  function quiet() { obs.forEach(function (o) { o.takeRecords(); }); }
  function watch(el) { if (!el || !('MutationObserver' in window)) return; var o = new MutationObserver(function (ms) { if (ms.every(function (m) { return m.target.closest && m.target.closest('.sg-dsc,.sg-nudge'); })) return; clearTimeout(t); if (cart && Date.now() < fresh && !saving()) { fresh = 0; paint(); return; } t = setTimeout(load, 60); }); /* the bag redrawing straight after its own save repaints from that save at once. Any other change reads the cart fresh (31 Oct) */ o.observe(el, { childList: true, subtree: true }); obs.push(o); }
  function boot() { watch(document.getElementById('sg-bag-root')); watch(document.querySelector('.cp-sum') && document.querySelector('.cp-sum').parentNode); if (document.querySelector('.sum-row')) load(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
/* menu links to the page you are already on close the menu and glide to the section. Older anchor names from the menu resolve to the sections on the new pages */
(function () {
  'use strict';
  var ALIAS = { 's_tiers-privileges': 'tiers-privileges', 'g_membership-tiers': 'membership-tiers', 'mistakes-before': 'before', 'mistakes-during': 'during', 'mistakes-after': 'after' };
  function find(h) {
    try { h = decodeURIComponent((h || '').replace(/^#/, '')); } catch (x) { return null; }
    if (!h) return null;
    return document.getElementById(h) || (ALIAS[h] && document.getElementById(ALIAS[h])) || document.getElementById(h.replace(/^[a-z]_/, '').replace(/^(mistakes|status|graphica)-/, ''));
  }
  function go(el, smooth) {
    var hdr = document.querySelector('.sg-hdr');
    var off = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sg-hdr')) || (hdr ? hdr.getBoundingClientRect().height : 0);
    var y = el.getBoundingClientRect().top + window.pageYOffset - off - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'instant' });
  }
  function closeMenu() {
    var m = document.getElementById('sg-menu');
    if (!m || m.hidden) return false;
    var x = m.querySelector('[data-sg-close]');
    if (x) x.click(); else { m.classList.remove('on'); m.hidden = true; document.documentElement.classList.remove('sg-lock'); }
    return true;
  }
  function host(h) { return h.replace(/^www\./, ''); }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('#sg-menu a[href], .sg-hdr a[href]');
    if (!a || a.target === '_blank') return;
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (host(u.hostname) !== host(location.hostname)) return;
    if (u.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return;
    /* a different query string is a different view of the page (e.g. ?view=stages), so let it load */
    if (u.search !== location.search) return;
    e.preventDefault(); e.stopPropagation();
    var was = closeMenu();
    if (window.SG && window.SG.closeMega) window.SG.closeMega();
    var el = find(u.hash);
    setTimeout(function () {
      if (el) { go(el, true); try { history.replaceState(history.state, '', location.pathname + location.search + u.hash); } catch (x) {} }
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    }, was ? 320 : 0);
  }, true);
  function arrive() {
    if (!location.hash || location.hash.length < 2) return;
    var raw; try { raw = decodeURIComponent(location.hash.slice(1)); } catch (x) { return; }
    var el = find(location.hash);
    if (!el) return;
    setTimeout(function () { go(el, false); }, document.getElementById(raw) ? 120 : 60);
  }
  if (document.readyState === 'complete') arrive(); else window.addEventListener('load', arrive);
})();
